import {
  Text
} from "./chunk-GIEK627K.js";
import {
  React
} from "./chunk-M54I523Y.js";

// packages/ui-lib/src/components/Heading.css.ts
var level = { "1": "Heading_1__3a80y50", "2": "Heading_2__3a80y51", "3": "Heading_3__3a80y52" };

// packages/ui-lib/src/components/Heading.tsx
var Levels = {
  "1": "h1",
  "2": "h2",
  "3": "h3"
};
var Heading = ({ children, level: level2 }) => /* @__PURE__ */ React.createElement(Text, {
  as: Levels[level2],
  size: "none",
  weight: "medium",
  className: level[level2]
}, children);

export {
  Heading
};
//# sourceMappingURL=chunk-HUDIEBGZ.js.map
